module.exports = __webpack_public_path__ + "img/default-headImg.fe1bd3eb.gif";